import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { pageRange, totalPages } from '../../utils/listHelpers';
import AppSelect from '../ui/AppSelect'

function ListPagination({
  page,
  pageSize,
  totalCount,
  onPageChange,
  onPageSizeChange,
  pageSizes = [12, 24, 48],
  className = '',
}) {
  const total = totalPages(totalCount, pageSize);
  if (totalCount <= pageSizes[0] && page === 1) return null;

  const from = totalCount === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalCount);
  const pages = pageRange(page, total);

  return (
    <div className={`ux-pagination ${className}`.trim()}>
      <div className="ux-pagination-meta">
        Showing <strong>{from}</strong>–<strong>{to}</strong> of <strong>{totalCount}</strong>
        {onPageSizeChange && (
          <label className="ux-pagination-size">
            <span>Per page</span>
            <AppSelect
              value={pageSize}
              onChange={(e) => onPageSizeChange(Number(e.target.value))}
              aria-label="Items per page"
            >
              {pageSizes.map((size) => (
                <option key={size} value={size}>{size}</option>
              ))}
            </AppSelect>
          </label>
        )}
      </div>
      <div className="ux-pagination-controls">
        <button
          type="button"
          className="ux-pagination-btn"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          aria-label="Previous page"
        >
          <ChevronLeft size={18} />
        </button>
        {pages.map((p) => (
          <button
            key={p}
            type="button"
            className={`ux-pagination-btn ux-pagination-num${p === page ? ' is-active' : ''}`}
            onClick={() => onPageChange(p)}
            aria-current={p === page ? 'page' : undefined}
          >
            {p}
          </button>
        ))}
        <button
          type="button"
          className="ux-pagination-btn"
          disabled={page >= total}
          onClick={() => onPageChange(page + 1)}
          aria-label="Next page"
        >
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
}

export default ListPagination;
